import type {IAsset} from '@netx/core-asset-next/schema';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

export const canViewAssetViews = (
	asset?: Pick<IAsset, 'permissionMatrix' | 'permissions'>,
): boolean => {
	if (!asset) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.READ,
		permissionName: PermissionName.DOWNLOAD,
	});
};
